import { FULL_SCREEN_OVERLAY } from "./_consts";
import { fadeIn, fadeOut } from "./_animationFade";

/**
 * 画面いっぱいオーバーレイの表示処理
 */
export function openFullScreenOverlay() {
  fadeIn(FULL_SCREEN_OVERLAY, 100);
  FULL_SCREEN_OVERLAY.classList.add('is-show');
}

/**
 * 画面いっぱいオーバーレイの非表示処理
 */
export function closeFullScreenOverlay() {
  fadeOut(FULL_SCREEN_OVERLAY, 100);
  FULL_SCREEN_OVERLAY.classList.remove('is-show');
}

/**
 * 画面いっぱいオーバーレイの表示非表示切り替え
 * 画面いっぱいオーバーレイの現在の表示状態をチェックして切り替える
 */
export function fullScreenOverlayDisplayControl() {
  if (FULL_SCREEN_OVERLAY.classList.contains('is-show')) {
    closeFullScreenOverlay();
  } else {
    openFullScreenOverlay();
  }
}